import LoadingIcon from 'assets/img/loading.svg'

export default ({ isLoading = true }) =>
  <div className="mt-4 mx-auto" style={{ maxWidth: '360px', display: isLoading ? 'block' : 'none' }}>
    <LoadingIcon />
  </div>
